import React from 'react';
import { motion } from 'framer-motion';
import { publicMotion, publicUi } from '../../styles/publicDesignSystem';

const PublicSectionHeader = ({
  badge,
  badgeIcon: BadgeIcon,
  title,
  subtitle,
  align = 'center',
  className = ''
}) => {
  const alignClass = align === 'left' ? 'text-left items-start' : 'text-center items-center';

  return (
    <motion.div
      {...publicMotion.sectionReveal}
      className={`flex flex-col ${alignClass} mb-14 ${className}`}
    >
      {badge ? (
        <div className={`${publicUi.pill} mb-6`}>
          {BadgeIcon ? <BadgeIcon className="h-4 w-4 mr-2" /> : null}
          {badge}
        </div>
      ) : null}

      {title ? <h2 className="text-3xl lg:text-4xl font-bold text-gray-900">{title}</h2> : null}
      {subtitle ? <p className="mt-4 text-lg text-gray-600 max-w-3xl">{subtitle}</p> : null}
    </motion.div>
  );
};

export default PublicSectionHeader;
